const NAME = "ALERTS_TEMPLATES";

export default NAME;
